import React from 'react';
import styled from 'styled-components';
import { useId } from '@reach/auto-id';
import { FocusStyles } from '../../../styles/FocusStyles';
import { AssistiveTechnologyOnly } from '../../../styles/AssistiveTechnologyOnly';
import { Paragraph } from '../../../src/atoms/Typography';
const getSize = ({ designSize }) => designSize === 'default' ? '1.5rem' : '1rem';
const Wrapper = styled.span `
  position: relative;
  display: grid;
  grid-template-columns: ${getSize} minmax(0, 1fr);
  grid-gap: 0.5rem;
  min-height: ${getSize};
`;
const StyledInput = styled.input `
  ${FocusStyles};
  border-radius: 50%;
  appearance: none;
  width: ${getSize};
  height: ${getSize};
  margin: 0 0.5rem 0 0;
  padding: 0;
  cursor: pointer;

  ::before {
    content: '';
    position: absolute;
    left: 0;
    top: 0;
    height: ${getSize};
    width: ${getSize};
    border-radius: 50%;
    border: 0.125rem solid
      ${props => props.disabled
    ? props.theme.LightGray
    : props.isError
        ? props.theme.BrandPrimary
        : props.checked
            ? props.theme.Green
            : props.theme.Black};
  }

  ::after {
    content: '';
    position: absolute;
    left: 0.25rem;
    top: 0.25rem;
    height: calc(${getSize} - 0.5rem);
    width: calc(${getSize} - 0.5rem);
    border-radius: 50%;
    background: ${props => props.checked
    ? props.isError
        ? props.theme.BrandPrimary
        : props.disabled
            ? props.theme.LightGray
            : props.theme.Green
    : 'transparent'};
  }
`;
const Label = styled.label `
  ${props => props.isLabelHidden && AssistiveTechnologyOnly};
  cursor: pointer;
  display: flex;
  /* Visually align vertically to radio icon */
  margin-top: ${props => (props.designSize === 'default' ? '0.2rem' : 0)};
`;
const TextWrapper = styled(Paragraph) `
  font-size: 0.8125rem;
  color: ${props => props.isDisabled
    ? props.theme.LightGray
    : props.isError
        ? props.theme.BrandPrimary
        : props.theme.Black};
`;
export function Radio({ name, checked = false, disabled = false, defaultChecked = false, isLabelHidden = false, children = null, value, onChange, size = 'default', status = 'ok', dataTestIdInput = 'radio-input', dataTestIdLabel = 'radio-label', }) {
    const id = useId();
    return (React.createElement(Wrapper, { designSize: size },
        React.createElement(StyledInput, { type: "radio", name: name, id: id, disabled: disabled, defaultChecked: defaultChecked, value: value, checked: checked, "aria-invalid": status === 'error', onChange: e => onChange(e.target.value), "data-testid": dataTestIdInput, designSize: size, isError: status === 'error' }),
        React.createElement(Label, { htmlFor: id, designSize: size, "data-testid": dataTestIdLabel, isLabelHidden: isLabelHidden },
            React.createElement(TextWrapper, { asHTMLTag: "span", isDisabled: disabled, isError: status === 'error' }, children))));
}
